import { useSyncExternalStore } from "react";

const MD_BREAKPOINT = 768;

function subscribe(callback) {
  const mql = window.matchMedia(`(min-width: ${MD_BREAKPOINT}px)`);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.innerWidth >= MD_BREAKPOINT;
}

export default function useResponsiveLimit(desktopDefault = 10) {
  const isDesktop = useSyncExternalStore(subscribe, getSnapshot);
  return isDesktop ? desktopDefault : 5;
}
